import { number, select } from '@frameio/i18n';
import { DotSeparator } from '@frameio/shared/components/DotSeparator';
import { Box, Text, theme } from '@frameio/vapor';
import { IconXCircleFill } from '@frameio/vapor-icons';
import type { TransferBatch } from '../../../types/uploader';
import { getProgressType } from '../../../utils';
import TEXT from './generated/TEXT/CanceledJobStatus';

TEXT.DEFINE(
  {
    /** Status label based on transfer type when canceled */
    canceledLabel: (progressType: string): string =>
      select(progressType, {
        DOWNLOAD: 'Download canceled',
        RENDER: 'Export canceled',
        other: 'Upload canceled',
      }),
    /** Status showing partial upload progress before cancellation */
    partialUploaded: (uploaded: number, total: number): string =>
      `Uploaded ${number(uploaded)} out of ${number(total)}`,
  },
  { number, select }
);

export const CanceledJobStatus = ({ job }: { job: TransferBatch }) => {
  const total = job.fileCounts?.total ?? 0;
  const uploaded = job.fileCounts?.uploaded ?? 0;
  const progressType = getProgressType(job);
  const hasPartialUploads = total !== uploaded && uploaded > 0;
  const canShowPartialUploads = hasPartialUploads;

  const canceledLabel = TEXT.canceledLabel(progressType);

  return (
    <Box display="flex">
      <IconXCircleFill color={theme.colors.icon.interactive.off} size={16} />
      <Box paddingLeft={4}>
        <Text color="tertiary" variant="secondary">
          {canceledLabel}
          {canShowPartialUploads && (
            <>
              <DotSeparator />
              <span>{TEXT.partialUploaded(uploaded, total)}</span>
            </>
          )}
        </Text>
      </Box>
    </Box>
  );
};
